import { SaveParams } from '@ai/api/index.type'
import { playTurboNextHostList } from '@/config/host'
import { NODE_ENV } from '@com/config/env'

const currentNextHost =
  playTurboNextHostList[NODE_ENV as keyof typeof playTurboNextHostList]

export function resolveAiId(id: SaveParams['id']): string {
  return `ai_${id}`
}

export function open(id: SaveParams['id']): void {
  const _id = resolveAiId(id)

  window.open(`${process.env.AI}#/?id=${id}`, _id)
}

export function resolveAiBannerId(id: SaveParams['id']): string {
  return `ai_banner_${id}`
}

export function openAiBanner(id: SaveParams['id']): void {
  const _id = resolveAiBannerId(id)
  const targetUrl = `${currentNextHost}/#/nl/url2image?id=${id}`
  window.open(targetUrl, _id)
}

export function getImageToVideoRedirectUrl(): string {
  return `${currentNextHost}/#/nl/image2video`
}

export function getAvatarToVideoRedirectUrl(): string {
  return `${currentNextHost}/#/nl/avatar2video`
}
